import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { BOX_BLUE } from '../../common/variables';

var UploadSuccessState = function UploadSuccessState(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? BOX_BLUE : _ref$color,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 49 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 50 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'upload-success-state ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 50 49'
        },
        React.createElement('path', {
            className: 'fill-color',
            d: 'M41.88,4.39l4,4.53L17,38.73,4.24,26,9,21.28l5.89,6.09L17,29.57l2.16-2.18,22.74-23M42,0,17,25.28,9,17,0,26,17,43,50,9,42,0Z',
            fill: color
        }),
        React.createElement('rect', {
            className: 'fill-color',
            width: '6',
            height: '3',
            fill: color,
            fillOpacity: '0.2',
            rx: '1.5',
            ry: '1.5',
            x: '4',
            y: '46'
        }),
        React.createElement('rect', {
            className: 'fill-color',
            width: '6',
            height: '3',
            fill: color,
            fillOpacity: '0.2',
            rx: '1.5',
            ry: '1.5',
            x: '33',
            y: '46'
        }),
        React.createElement('rect', {
            className: 'fill-color',
            width: '21',
            height: '3',
            fill: color,
            fillOpacity: '0.2',
            rx: '1.5',
            ry: '1.5',
            x: '11',
            y: '46'
        })
    );
};

UploadSuccessState.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default UploadSuccessState;
import PropTypes from 'prop-types';